import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ConvertMediaMutationVariables = Types.Exact<{
  input: Types.ConvertMediaInput;
}>;


export type ConvertMediaMutation = { convertMedia?: { success?: boolean | null, jobScheduleId?: string | null } | null };


export const ConvertMediaDocument = /*#__PURE__*/ gql`
    mutation convertMedia($input: ConvertMediaInput!) {
  convertMedia(input: $input) {
    success
    jobScheduleId
  }
}
    `;

export function useConvertMediaMutation() {
  return Urql.useMutation<ConvertMediaMutation, ConvertMediaMutationVariables>(ConvertMediaDocument);
};